<template>
    <a-layout class="main">
        <main-header></main-header>
        <a-layout class="card main-card">
            <a-layout-sider :width="mobile ? 80 : 150" class="left-menu" style="background: #fff">
                <Menu :indent="mobile ? 10 : 64"></Menu>
            </a-layout-sider>
            <a-layout class="main-brench">
                <keep-alive>
                    <router-view class="panel"/>
                </keep-alive>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Menu from './components/Menu.vue'

const handle = window.matchMedia('(max-width: 599px)');

export default {
    data: () => ({
        mobile: handle.matches,
    }),
    created() {
        handle.onchange = (e) => this.mobile = e.matches;
    },
    components: {
        MainHeader, Menu
    }
}
</script>

<style lang="less">
body {
    background-color: #e6e6e6 !important;
    min-width: 1000px;
}
@media screen and (max-width: 1000px) {
    body {
        min-width: 100%;
    }
}
.main {
    height: 100%;
}
.panel {
    padding: 10px;
}
</style>

<style lang="less" scoped>
.ant-layout {
    background: none;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    font-family: none;
}
.main-card {
    margin: 10px auto;
    width: 1000px;
}
.main-brench {
    background-color: #f6f6f6;
    padding: 10px;
}
@media screen and (min-width: 1000px) {
    // .stat-card-mobile {
    //     display: none;
    // }
}
@media screen and (max-width: 1000px) {
    .main-card {
        margin: 0;
        width: 100%;
    }
}
</style>